import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIfixitComponent } from './simple-icons-ifixit.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIfixitComponent ],
    exports:      [ SimpleIconsIfixitComponent ],
    bootstrap:    []
})
export class SimpleIconsIfixitModule {}
